import { useEffect, useState } from 'preact/hooks';
import { quranText } from '../data/islam';
import { EVIDENCE } from '../data/islamEvidence';

// [Al-Ḥijr: 15:16] on the start-up screen each time Ahillah opens (BUILD-SPEC item 43, the owner's choice: it speaks
// of looking), in the King Fahd Complex's face. It shows once that face has loaded (asked for in src/main.tsx), so it
// never shows in another face, and nothing waits for it: the app opens as soon as it is ready.

const FACE = '16px "KFGQPC Hafs"';

export function StartVerse() {
  const [face, setFace] = useState(() => !!document.fonts?.check(FACE, 'ٱ'));
  useEffect(() => {
    if (face || !document.fonts) return;
    let live = true;
    document.fonts.load(FACE, 'ٱ').then((got) => live && got.length > 0 && setFace(true)).catch(() => undefined);
    return () => {
      live = false;
    };
  }, []);
  if (!face) return null;
  const e = EVIDENCE['Q-46'];
  return (
    <div class="start-verse">
      <p class="quran-text" lang="ar" dir="rtl">{quranText(e.arabic)}</p>
      <p class="start-verse-en">{e.english}</p>
      <p class="start-verse-ref">{e.ref}</p>
    </div>
  );
}
